import classNames from 'clsx';
import React, { FC, memo } from 'react';
import { datalistInlineRenameEnabled } from 'reactApp/appHelpers/featuresHelpers';
import { useRenameInlineDoubleClick } from 'reactApp/hooks/useRenameInlineDoubleClick';
import { EInlineEditPlace } from 'reactApp/modules/modifying/modifying.types';
import { ContentEditable } from 'reactApp/ui/ContentEditable/ContentEditable';
import type { ItemNameProps } from 'reactApp/ui/DataListItemRow/DataListItemRow.types';
import { NameComponent } from 'reactApp/ui/Name/Name';
import { noop } from 'reactApp/utils/helpers';

import styles from '../DataListItemRow.css';

export const ItemName: FC<ItemNameProps> = memo(function ItemName({ name, ext, loading, id = '', isRenameAvailable = false }) {
    const { isEdit, handleDoubleClick, onRename } = useRenameInlineDoubleClick(name, id, EInlineEditPlace.datalistRow, ext);

    return (
        <div className={classNames({ [styles.name]: true, [styles.loading]: loading })}>
            {isEdit ? (
                <div className={styles.edit}>
                    <ContentEditable value={name} onEdit={onRename} selectAllOnFocus />
                </div>
            ) : (
                <NameComponent
                    name={name}
                    extension={ext}
                    truncate
                    showTooltip
                    onDoubleClick={isRenameAvailable && datalistInlineRenameEnabled ? handleDoubleClick : noop}
                />
            )}
        </div>
    );
});
